<template>
  <div
    class="displayField"
    :data-testid="`displayField-${uuid}`"
    :class="{'displayField--with-icon': $slots.icon}"
  >
    <div
      class="displayFieldLabel"
      :style="{'margin-left': leftMargin}"
      aria-label="Label Input"
    >
      <slot name="label" />
    </div>
    <div
      v-if="$slots.icon"
      class="displayLabelIcon"
    >
      <slot name="icon" />
    </div>
    <div
      class="displayFieldValue"
      aria-label="Value Input"
    >
      <slot name="value" />
    </div>
    <TrashIcon
      v-if="allowDelete"
      ref="formatted-row-trash-icon"
      class="formatted-row-trash-icon"
      data-testid="formatted-row-trash-icon"
      @click="handleDelete"
    />
  </div>
</template>

<script>
import TrashIcon from '@/components/svgs/TrashIcon.vue';

export default {
  name: 'SlottedRow',
  components: {
    TrashIcon,
  },
  inject: {
    leftMargin: {
      default: '0px',
    },
  },
  props: {
    allowDelete: {
      type: Boolean,
      default: false,
    },
    handleDelete: {
      type: Function,
      default: () => {},
      required: false,
    },
    uuid: {
      type: String,
      default: () => Math.random().toString(36).substring(7),
    },
  },
};
</script>

<style lang="scss" scoped>
.displayField {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
  margin-left: -3px;
  &--with-icon {
    gap: 0;
  }

  .displayFieldLabel, .displayFieldValue {
    width: 100%;
    word-break: break-word;
    padding: 0 0px;
  }
  .displayFieldValue {
    align-self: center;
  }
  .displayLabelIcon {
    position: relative;
    bottom: 1px;
    right: 8px;
    width: 17px;
  }
}
.formatted-row-trash-icon {
  position: absolute;
  right: -24px;
  top: 1px;
  width: 20px;
  height: 20px;
}
</style>
